define('viewmodels/VisualAnalytics/InherentWeightings',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'services/logger', 'durandal/system', 'services/utils', 'viewmodels/GeneralSettings'],
    function (ko, router, appsecurity, navigation, app, logger, system, utils, ObjGeneralSettings) {
        var title = 'InherentWeightings';

        var IWViewModel = {
            activate: activate,
            title: title,
            attached: attached,
            detached: detached,
            appsecurity: appsecurity,
            GetSurveyCategoryTabs: GetSurveyCategoryTabs,
            SurveyCategoryList: ko.observableArray([]),
            AssessmentTypeList: ko.observableArray([]),
            SelectedAssessmentId: ko.observable(),
            AssessmentType: ko.observable(),
            AssessmentTypeId: ko.observable(),
            ScreenName: ko.observable(),
            SurveyCategoryList: ko.observableArray([]),
            SelectedSurveyComponentId: ko.observable(),
            RiskAreaTypeList: ko.observableArray([]),

            countEntry: ko.observable(0),
            RiskAreaTabClicked: ko.observable(),
            WeightingsType: ko.observable(), //this specifies the type of the wightings. RA:Area|OA:Overall|BUL:business unit level|BULOverall :business unit level
            RAName: ko.observable(),
            ThemeId: ko.observable(),
            ClickedRiskAreaName: ko.observable(),
            RiskFactorList: ko.observableArray(),
            ClickedRiskAreaType: ko.observable(),
            hasSubArea: ko.observable(),
            Parent_Id: ko.observable(),
            Type: ko.observable(),
            copyDataButtonClicked: ko.observable(false),
            SurveyCategoryTabClickIW: SurveyCategoryTabClickIW,
            SurveyTypeClicked: ko.observable(),
            SurveyCategoryID: ko.observable(),
            GetRiskLevelDetails: GetRiskLevelDetails,
            ShowDetailsTab: ko.observable(),
            BusinessLevelList: ko.observable([]),
            RiskAreaList: ko.observableArray(),
            RiskLevelTabClick: RiskLevelTabClick,
            AreaLeveljstree: ko.observableArray([]),
            nodeClickEvent: nodeClickEvent,
            InitiateLevelTree: InitiateLevelTree,
            EditableBusinessunitTotal: ko.observable(0),
            ToggleNavigationMenu1: ToggleNavigationMenu1,
            ToggleNavigationMenu2: ToggleNavigationMenu2,
            CollapseAllTreeView: CollapseAllTreeView,
            selectedAreaId: ko.observable(),
            weightingsTableTitle: ko.observable(),
            IsDeadNode: ko.observable(0),
            GetInherentWeights: GetInherentWeights,
            BusinessUnits: ko.observableArray([]),
            AreasOrQuestions: ko.observableArray([]),
            inherentWeight: ko.observableArray([]),
            totalWeightList: ko.observableArray([]),
            EditableBusinessunitTotal: ko.observable(0),
            EditableBusinessUnitName: ko.observable(),
            setSelectedBusinessUnit: setSelectedBusinessUnit,
            EditBUWeights: EditBUWeights,
            SelectBusinessUnit: ko.observable(),

            TaxonomyLevels: ko.observableArray([]),
            selectedOrgLevelAP: ko.observable(),
            selectedTaxonomyLevel: ko.observable(),
            selectedBULevel: ko.observable(),
            IsLowestLevelSelected: ko.observable(false),
            GetQuestionTypes: GetQuestionTypes,
            QuestionTypes: ko.observableArray([]),
            saveWeights: saveWeights,
            checkCopyOver: checkCopyOver,
            WeightingsList: ko.observableArray([]),
            downloadWeightings: downloadWeightings,
            RefreshWeights: RefreshWeights,
            SelectedOrgLevel: ko.observable(),
            GetTaxonomyLevels: GetTaxonomyLevels,
            TaxonomyLevelChanged: TaxonomyLevelChanged,
            screenType: ko.observable(),
            uploadselectedOrganizationLevel: ko.observable(),
            ClickedBulevel: ko.observable(),
            isHeaderQuestion: ko.observable(0),
            ControlsAccess: ko.observable(true),
            totalValidityFlag: ko.observable(1),
            hasChildNodes: ko.observable(false),
            decimalLimit: ko.observable(5),
            SelectedScenarioId: ko.observable(),
            //GetAllRiskLevels: GetAllRiskLevels

            ObjGeneralSettings: ObjGeneralSettings,
            LocaleCheckFlag: ko.observable(false),

        };

        return IWViewModel;

        function activate() {
            try {
                if (IWViewModel.ObjGeneralSettings === undefined || IWViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((IWViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || IWViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && IWViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                    IWViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {
                        if (IWViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || IWViewModel.ObjGeneralSettings.LocalizedTextList() == null || IWViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || IWViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || IWViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                            IWViewModel.LocaleCheckFlag(false);
                        else
                            IWViewModel.LocaleCheckFlag(true);
                    });
                } else
                    IWViewModel.LocaleCheckFlag(true);

                IWViewModel.ScreenName(
                    //'Inherent Weightings'
                    (!IWViewModel.LocaleCheckFlag() || IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InherentWeightings') == -1) ? 'Inherent Weightings' : IWViewModel.ObjGeneralSettings.LocalizedTextList()[IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InherentWeightings')].Name()
                );

            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: activate() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function detached() {
            try {
                var Id = IWViewModel.appsecurity.getParameterByName('atype');
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: detached() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
        };

        function attached() {
            try {
                //GetSurveyCategoryTabs();

                if (IWViewModel.ObjGeneralSettings === undefined || IWViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((IWViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || IWViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && IWViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                    IWViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {
                        if (IWViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || IWViewModel.ObjGeneralSettings.LocalizedTextList() == null || IWViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || IWViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || IWViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                            IWViewModel.LocaleCheckFlag(false);
                        else
                            IWViewModel.LocaleCheckFlag(true);
                    });
                }

                IWViewModel.EditableBusinessUnitName(
                    //"Editable BusinessUnit name"
                    (!IWViewModel.LocaleCheckFlag() || IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditableBusinessUnitname') == -1) ? 'Editable BusinessUnit name' : IWViewModel.ObjGeneralSettings.LocalizedTextList()[IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditableBusinessUnitname')].Name()
                );
                GetQuestionTypes();
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: attached() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function TaxonomyLevelChanged() {
            for (var i = 0; i < IWViewModel.TaxonomyLevels().length; i++) {
                if (IWViewModel.TaxonomyLevels()[i].LevelId() == IWViewModel.selectedTaxonomyLevel()) {
                    if (IWViewModel.TaxonomyLevels()[i].isMaxLevel() == 1) {
                        IWViewModel.IsLowestLevelSelected(true);
                    }
                    else {
                        IWViewModel.IsLowestLevelSelected(false);
                    }

                    break;
                }
            }
        }

        function GetSurveyCategoryTabs(AssessmentId, ScenarioId, StateSelected) {
            try {

                IWViewModel.AssessmentTypeId(AssessmentId);

                IWViewModel.SelectedScenarioId(ScenarioId);

                $.ajax({
                    url: "/api/Visualization/GetSurveyCategoryTabsByZATRAT",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { "AssessmentId": AssessmentId, "StateSelected": StateSelected }
                })
                    .success(function (jsonResult, success) {
                        try {
                            //$('#SurveyCategoryTab_IW').show();
                            //$('#mainLoader').hide();
                            if (jsonResult != null) {
                                var mappedTabList = $.map(jsonResult, function (result) {
                                    return new SurveyCategoryModel(result);
                                });
                                IWViewModel.SurveyCategoryList(mappedTabList);
                                $('#SurveyCategoryTab_IW').tabs();
                                $('#SurveyCategoryTab_IW').tabs('refresh');
                                $('#SurveyCategoryTab_IW').tabs({ active: 0 });
                                $($('#SurveyCategoryTabsDiv li').get(0)).trigger('click');
                                scrollableTabs();
                            }
                        }
                        catch (e) {
                            var msg = 'Exception: ' + e + ' | Source: GetSurveyCategoryTabs() Success method in InherentWeightings.js';
                            logger.logMessage(msg);
                        }

                    })
                    .fail(function (error, status) {
                        if (error.status == 401) {
                            app.showMessage(((!IWViewModel.LocaleCheckFlag() || IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : IWViewModel.ObjGeneralSettings.LocalizedTextList()[IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK")
                                        navigation.unauthorized();
                                })
                        }
                        else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetSurveyCategoryTabs() method in InherentWeigthings.js';
                            logger.logMessage(msg);
                        }

                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetSurveyCategoryTabs() method in InherentWeigthings.js';
                logger.logMessage(msg);
            }
        }

        function GetTaxonomyLevels() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                getTaxonomyLevel = {

                    url: "/api/WeightingsThresholds/GetTaxonomyLevel",
                    type: "GET",
                    data: { "SurveyCategoryID": IWViewModel.SurveyCategoryID(), "Show_Lowest_Level": 0 },
                    headers: headers
                };
                $.ajax(getTaxonomyLevel)
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetTaxonomyLevels() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                if (jsonResult !== null) {
                    IWViewModel.TaxonomyLevels([]);
                    var MappedTaxonomyLevel = $.map(jsonResult, function (result) {
                        return new TaxonomyModel(result);
                    });
                    IWViewModel.TaxonomyLevels(MappedTaxonomyLevel);

                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage(((!IWViewModel.LocaleCheckFlag() || IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : IWViewModel.ObjGeneralSettings.LocalizedTextList()[IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then((option) => {
                                if (option === "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetTaxonomyLevels method in InherentWeightings.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxFail in GetTaxonomyLevels method in InherentWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }

        function GetRiskLevelDetails() {
            try {
                $.ajax({
                    url: "/api/WeightingsThresholds/getAllBusinessUnitLevels",
                    data: { "type": IWViewModel.AssessmentTypeId(), "Page_Type": "W" },
                    type: "GET",
                    async: false,
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: ajax call in GetRiskLevelDetails() method in InherentWeightings.js';
                logger.logMessage(msg);

            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult !== null && jsonResult.length > 0) {
                        var MappedBUModelList = $.map(jsonResult, (result) => {
                            return new BusinessLevelModel(result);
                        });

                        IWViewModel.BusinessLevelList(MappedBUModelList);


                        $('#RaTab_IW').tabs();
                        $('#RaTab_IW').tabs('refresh');
                        $('#RaTab_IW').tabs({ active: 0 });
                        $($('#RaTab_IW li').get(0)).trigger('click');
                    }
                    else
                        logger.logError(((!IWViewModel.LocaleCheckFlag() || IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage') == -1) ? 'An error occurred. Please contact your Application Administrator.' : IWViewModel.ObjGeneralSettings.LocalizedTextList()[IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ContactAdminErrorMessage')].Name()), 'Error', system.getModuleId(IWViewModel), true);
                }
                catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetRiskLevelDetails() method in InherentWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }

        function downloadWeightings(data, event) {
            try {
                //BU vs Areas
                //AssessmentType, SurveyCategoryId, AreaId
                var payLoad = {
                    t: appsecurity.getAuthenticationInfo(), AssessmentType: data.AssessmentTypeId(), SurveyCategoryId: data.SurveyCategoryID(), AreaId: data.selectedAreaId(), OrgLevel: data.SelectedOrgLevel()
                };
                utils.postAndRedirect(rootPath + "/FileDownload/DownloadExcelInherentWeightings", payLoad, '_blank');
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | downloadDocuments() in InherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function RefreshWeights() {
            try {
                GetInherentWeights();
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: RefreshWeights() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
        }



        function SurveyCategoryTabClickIW(data, event) {
            try {

                IWViewModel.SurveyTypeClicked(data.SurveyGroupShortName());
                IWViewModel.SurveyCategoryID(data.SurveyCategoryId());
                GetTaxonomyLevels();
                GetRiskLevelDetails();
                $('#SurveyCategoryTabsDiv li').removeClass('active');
                $('#ParentTab_' + data.SurveyCategoryId()).addClass('active');
                //Write your logic here to calculate for overall tab

                //if (data.SurveyCategoryId() === -999)
                //GetAllRiskLevels(data.SurveyCategoryId());
                //GetAllRiskAreasForCategories();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SurveyCategoryTabClickIW() method in AMLWeightings.js';
                logger.logMessage(msg);
            }
        }

        function RiskLevelTabClick(data, event) {
            try {
                IWViewModel.ClickedBulevel(data.Bulevel());
                $('#RiskAreaUl li').removeClass('active');
                $('#ChildTab_' + data.Bulevel()).addClass('active');
                IWViewModel.SelectedOrgLevel(data.Bulevel());
                if (data.Bulevel() == "0")
                    IWViewModel.screenType("W");
                else
                    IWViewModel.screenType("OW");
                InitiateLevelTree();
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: ajaxSuccess in RiskLevelTabClick() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function InitiateLevelTree() {
            try {

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                getjsTreeAreaLevelINHWIA = {

                    url: "/api/Configuration/GetAllRiskAreasForThreshold",
                    type: "GET",
                    data: { "RiskAreType": IWViewModel.SurveyTypeClicked(), "SurveyCategoryID": IWViewModel.SurveyCategoryID().toString(), "AssessmentTypes": IWViewModel.AssessmentTypeId().toString(), "ScreenType": IWViewModel.screenType() },
                    headers: headers
                };
                $.ajax(getjsTreeAreaLevelINHWIA)
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: ajax call in InitiateLevelTree() method in InherentWeightings.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {

                //$('#mainLoader').hide();
                //$('.content').show();

                if (jsonResult !== null) {
                    //implement js tree logic here
                    IWViewModel.AreaLeveljstree(jsonResult.AreaLevelsData);

                    var MappedJsTreeList = $.map(jsonResult.AreaLevelsData["#"], function (result) {
                        return new jsTreeModel(result);
                    });

                    $('#jsTreeAreaLevelINHWIA').treeview({
                        data: MappedJsTreeList,
                        onNodeSelected: nodeClickEvent
                    });


                    $("#jsTreeAreaLevelINHWIA ul:first li:first").trigger("click");
                }
            }

            function filterJsTree(TreeStructure) {

                return TreeStructure.filter(
                    function (item) {
                        if (item.nodes !== undefined && item.nodes.length > 0) {
                            item.nodes = filterJsTree(item.nodes);
                        }

                        if (item.showLevel === 1)
                            return true;
                        return false;

                    }
                );
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage(((!IWViewModel.LocaleCheckFlag() || IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : IWViewModel.ObjGeneralSettings.LocalizedTextList()[IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then((option) => {
                                if (option === "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in InitiateLevelTree() method in InherentWeightings.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxFail in InitiateLevelTree() method in InherentWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }

        function nodeClickEvent(event, node) {
            try {

                //$('#loadingMainInherentDiv').show();
                //$('#WeightingsTableDiv').hide();
                IWViewModel.selectedAreaId(node.id);
                IWViewModel.weightingsTableTitle(node.text);
                IWViewModel.IsDeadNode(node.dead_node);
                //GetControlsWeight();
                //Make that API Call
                //Get Inherent Weights
                GetInherentWeights();

            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: BusinessLevelModel() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function GetInherentWeights() {
            try {

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Visualization/GetInherentWeights",
                    type: "GET",
                    headers: headers,
                    data: { "AssessmentType": IWViewModel.AssessmentTypeId(), "SurveyCategoryId": IWViewModel.SurveyCategoryID().toString(), "AreaId": IWViewModel.selectedAreaId(), "OrgLevel": IWViewModel.SelectedOrgLevel(), "ScenarioId": IWViewModel.SelectedScenarioId() }
                })
                    .success((jsonResult, success) => {
                        try {

                            //$('#loadingMainInherentDiv').hide();
                            //$('#WeightingsTableDiv').show();
                            if (jsonResult !== null) {
                                IWViewModel.BusinessUnits([]);
                                IWViewModel.AreasOrQuestions([]);
                                IWViewModel.inherentWeight([]);

                                IWViewModel.decimalLimit(jsonResult.precisionObject);

                                // Map Business Units.
                                if (jsonResult.BUWiseWeightings.length > 0) {
                                    var mappedBusinessUnitData = $.map(jsonResult.BUWiseWeightings, (result) => {
                                        return new BusinessLevelsModel(result);
                                    });
                                    IWViewModel.BusinessUnits([]);
                                    IWViewModel.BusinessUnits(mappedBusinessUnitData);
                                    //IWViewModel.EditableBusinessUnitName(mappedBusinessUnitData[0].BUShortName());


                                }

                                IWViewModel.totalValidityFlag(1);

                                for (var i = 0; i < IWViewModel.BusinessUnits().length; i++) {
                                    if (IWViewModel.BusinessUnits()[i].total() == 100.00000 || IWViewModel.BusinessUnits()[i].total() == 0.00000) {
                                        IWViewModel.totalValidityFlag(1);
                                    }
                                    else {
                                        IWViewModel.totalValidityFlag(0);
                                        break;
                                    }
                                }


                                IWViewModel.AreasOrQuestions([]);
                                if (jsonResult.AreaWiseWeightings.length > 0) {
                                    var mappedAreasOrQuestions = $.map(jsonResult.AreaWiseWeightings, (result) => {
                                        return new RiskAreaModel(result);
                                    });
                                    IWViewModel.AreasOrQuestions([]);
                                    IWViewModel.AreasOrQuestions(mappedAreasOrQuestions);
                                }
                                setSelectedBusinessUnit(mappedBusinessUnitData[0].BUId());
                                IWViewModel.inherentWeight([]);
                                if (jsonResult.WeightingsList.length > 0) {
                                    var mappedControlsWeight = $.map(jsonResult.WeightingsList, (result) => {
                                        return new WeightingsModel(result);
                                    });
                                    IWViewModel.inherentWeight([]);
                                    IWViewModel.inherentWeight(mappedControlsWeight);
                                }


                                let scrollHeight = "27rem";

                                if ($.fn.DataTable.isDataTable('#WeightingsTable')) {
                                    IWViewModel.AreasOrQuestions([]);
                                    var tableObj = $('#WeightingsTable').DataTable();
                                    tableObj.fixedHeader.disable();
                                    tableObj.destroy();
                                    $('#WeightingsTable tbody tr').remove();
                                    $("#WeightingsTableHeader > th").remove();
                                    $("#WeightingsTableTotal > th").remove();
                                    var htmlHeader = '';
                                    //Code for header of the table
                                    if (IWViewModel.IsDeadNode() === 1) {
                                        htmlHeader += '<th class="site_name Weightings-Fixed-Column">';
                                        //htmlHeader += 'Questions ↓ / Business Units →';
                                        htmlHeader += (!IWViewModel.LocaleCheckFlag() || IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('QuestionsvsBusinessUnits') == -1) ? 'Questions ↓ / Business Units →' : IWViewModel.ObjGeneralSettings.LocalizedTextList()[IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('QuestionsvsBusinessUnits')].Name();
                                        htmlHeader += '</th > \
                                                <th class="site_name header-ellipsis" data-bind="text:$root.EditableBusinessUnitName">'+ IWViewModel.EditableBusinessUnitName() + '</th>';
                                    }
                                    else {
                                        htmlHeader += '<th class="site_name Weightings-Fixed-Column" >';
                                        htmlHeader += (!IWViewModel.LocaleCheckFlag() || IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AreasvsBu') == -1) ? 'Areas ↓ / Business Units →' : IWViewModel.ObjGeneralSettings.LocalizedTextList()[IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AreasvsBu')].Name();
                                            //Areas ↓ / Business Units →
                                        htmlHeader += '</th><th class="site_name header-ellipsis" data-bind="text:$root.EditableBusinessUnitName">'+ IWViewModel.EditableBusinessUnitName() + '</th>';
                                    }
                                    for (var i = 0; i < IWViewModel.BusinessUnits().length; i++) {
                                        htmlHeader += '<th class="site_name header-ellipsis"><div style="display:flex"><label id=' + IWViewModel.BusinessUnits()[i].BUId() + ' title="' + IWViewModel.BusinessUnits()[i].BUName() + '">' + IWViewModel.BusinessUnits()[i].BUShortName() + '</label> &emsp; <icon class="fa fa-edit float-right float-top" title="Edit Weights" data-bind="click: $root.EditBUWeights"></icon></div></th>';
                                    }

                                    $('#WeightingsTableHeader').html(htmlHeader);
                                    document.getElementById('WeightingsTableHeader').innerHTML = htmlHeader;
                                    ko.cleanNode(document.getElementById('WeightingsTableHeader'));
                                    ko.applyBindings(IWViewModel, document.getElementById("WeightingsTableHeader"));
                                    var htmlFooter = '';
                                    htmlFooter = '<th  class="site_name">Total</th>\
                                        <th class="text-center heatmap-grey" data-bind="css:{\'heatmap-red\' :($root.EditableBusinessunitTotal()!=100.00000&&$root.EditableBusinessunitTotal()!=0.00),\'heatmap-grey\' : ($root.EditableBusinessunitTotal()==100.00000||$root.EditableBusinessunitTotal()==0.00000)}"> <span data-bind="text:$root.EditableBusinessunitTotal" > </span> <span> % </span> </th>';
                                    for (i = 0; i < IWViewModel.BusinessUnits().length; i++) {
                                        if (Number(IWViewModel.BusinessUnits()[i].total()).toFixed(IWViewModel.decimalLimit()) != 100.00000 && Number(IWViewModel.BusinessUnits()[i].total()).toFixed(IWViewModel.decimalLimit()) != 0.00000) {
                                            htmlFooter += '<th class="heatmap-red text-center " >' + IWViewModel.BusinessUnits()[i].total() + ' % ' + '</th>';
                                        }
                                        else {
                                            htmlFooter += '<th class="heatmap-grey text-center" >' + IWViewModel.BusinessUnits()[i].total() + ' % ' + '</th>';
                                        }

                                    }
                                    $('#WeightingsTableTotal').append(htmlFooter);
                                    document.getElementById('WeightingsTableTotal').innerHTML = htmlFooter;
                                    ko.cleanNode(document.getElementById('WeightingsTableTotal'));
                                    ko.applyBindings(IWViewModel, document.getElementById("WeightingsTableTotal"));

                                    if (jsonResult.AreaWiseWeightings.length > 0) {
                                        var mappedAandQ = $.map(jsonResult.AreaWiseWeightings, (result) => {
                                            return new RiskAreaModel(result);
                                        });

                                        IWViewModel.AreasOrQuestions(mappedAandQ);
                                        setSelectedBusinessUnit(mappedBusinessUnitData[0].BUId());
                                    }
                                    //IWViewModel.AreasOrQuestions(mappedAreasOrQuestions);
                                    tableObj = $('#WeightingsTable').DataTable(
                                        {
                                            'aoColumnDefs': [{
                                                'bSortable': false,
                                                "targets": "_all"
                                            }],
                                            "aaSorting": [],
                                            scrollY: scrollHeight,
                                            scrollX: true,
                                            scrollCollapse: true,
                                            paging: false,
                                            "bInfo": false,
                                            "bAutoWidth": false,
                                            fixedColumns: {
                                                leftColumns: 1
                                            },
                                            fixedheader: {
                                                header: true
                                                //footer:true
                                            }

                                        }).draw();


                                }
                                else if (!$.fn.DataTable.isDataTable('#WeightingsTable')) {
                                    $('#WeightingsTable').DataTable(
                                        {
                                            'aoColumnDefs': [{
                                                'bSortable': false,
                                                "targets": "_all"
                                            }],
                                            "aaSorting": [],
                                            scrollY: scrollHeight,
                                            scrollX: true,
                                            scrollCollapse: true,
                                            paging: false,
                                            "bInfo": false,
                                            "bAutoWidth": false,
                                            fixedColumns: {
                                                leftColumns: 1
                                            },
                                            fixedheader: {
                                                header: true
                                                //footer: true
                                            }

                                        });
                                }


                            }
                        }
                        catch (e) {
                            let msg = 'Exception: ' + e + ' | Source: nodeClickEvent() Success method in InherentWeightings.js';
                            logger.logMessage(msg);
                        }

                    })
                    .fail((error, status) => {
                        if (error.status === 401) {
                            app.showMessage(((!IWViewModel.LocaleCheckFlag() || IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : IWViewModel.ObjGeneralSettings.LocalizedTextList()[IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then((option) => {
                                    if (option === "OK")
                                        navigation.unauthorized();
                                });
                        }
                        else {
                            let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in nodeClickEvent() method in InherentWeightings.js';
                            logger.logMessage(msg);
                        }

                    });
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: nodeClickEvent() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function saveWeights() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    //Enter your own api
                    url: "/api/Visualization/SaveInherentWeightings?AssessmentType=" + IWViewModel.AssessmentTypeId() + "&SurveyCategoryId=" + IWViewModel.SurveyCategoryID().toString() + "&AreaId=" + IWViewModel.selectedAreaId() + "&OrgLevel=" + IWViewModel.SelectedOrgLevel() + "&ScenarioId=" + IWViewModel.SelectedScenarioId() , //to save the bu level wieghtings.
                    headers: headers,
                    type: "POST",
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify($.map(IWViewModel.WeightingsList(), function (item) {
                        return { BuId: item.BuId(), RiskAreaId: item.RiskAreaId(), WeightingValue: item.WeightingValue() };
                    }))
                })
                    .success(ajaxSuccessInherentWeights)
                    .fail(ajaxFailInherentWeights);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxCall in saveWeights() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
            function ajaxSuccessInherentWeights(jsonResult, status) {
                try {
                    if (jsonResult != null && jsonResult != 0) {
                        logger.logSuccess(
                            //'Inherent Weightings are saved successfully.'
                            (!IWViewModel.LocaleCheckFlag() || IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InherentWeightsSaveSuccess') == -1) ? 'Inherent Weightings are saved successfully.' : IWViewModel.ObjGeneralSettings.LocalizedTextList()[IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InherentWeightsSaveSuccess')].Name()
                            , 'Success', system.getModuleId(IWViewModel), true);
                        GetInherentWeights();
                    }
                    else {
                        logger.logError(
                            //'Some error occurred while saving.'
                            (!IWViewModel.LocaleCheckFlag() || IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InherentWeightsSaveFail') == -1) ? 'Some error occurred while saving.' : IWViewModel.ObjGeneralSettings.LocalizedTextList()[IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InherentWeightsSaveFail')].Name
                            , 'Error', system.getModuleId(IWViewModel), true);
                    }
                }

                catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in saveWeights() method in InherentWeightings.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFailInherentWeights(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage(((!IWViewModel.LocaleCheckFlag() || IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : IWViewModel.ObjGeneralSettings.LocalizedTextList()[IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in saveWeights() method in InherentWeightings.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxFail() method in saveWeights() method in InherentWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }

        function checkCopyOver() {
            app.showMessage(
                (!IWViewModel.LocaleCheckFlag() || IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveWeightsWarning') == -1) ? "<b> By clicking the Confirm button, I acknowledge the following: </b> \n <br> 1. I have reviewed the weightings provided on this screen; <br> 2. Error(s) / warning(s) displayed on the screen will need to be corrected prior to executing the calculation engine; and <br> 3. Incorrect inputs provided might results in inaccurate risk rating calculations. <br> <b> If you do not wish to proceed, please Deny. </b> " : IWViewModel.ObjGeneralSettings.LocalizedTextList()[IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveWeightsWarning')].Name
                //"<b> By clicking the Confirm button, I acknowledge the following: </b> \n <br> 1. I have reviewed the weightings provided on this screen; \n <br> 2. Error(s) / warning(s) displayed on the screen will need to be corrected prior to executing the calculation engine; and \n <br> 3. Incorrect inputs provided might results in inaccurate risk rating calculations. \n <br> <b> If you do not wish to proceed, please Deny. </b> "
                , (!IWViewModel.LocaleCheckFlag() || IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Acknowledgement') == -1) ? "Acknowledgement" : IWViewModel.ObjGeneralSettings.LocalizedTextList()[IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Acknowledgement')].Name
                //"Acknowledgement"
                , [(!IWViewModel.LocaleCheckFlag() || IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? "Confirm" : IWViewModel.ObjGeneralSettings.LocalizedTextList()[IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name()
                    //"Confirm"
                    ,
                    (!IWViewModel.LocaleCheckFlag() || IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DenyButton') == -1) ? "Deny" : IWViewModel.ObjGeneralSettings.LocalizedTextList()[IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('DenyButton')].Name()
                    //"Deny"
                ]
                , true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus", popupIcon: 'title-icon col-md-1 fa fa-copy' })
                .then(function (option) {
                    if (option == ((!IWViewModel.LocaleCheckFlag() || IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton') == -1) ? "Confirm" : IWViewModel.ObjGeneralSettings.LocalizedTextList()[IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ConfirmButton')].Name())) {
                        if (IWViewModel.EditableBusinessunitTotal() != 100.00000) {
                            logger.logError(
                                //'The total for weightings should be 100.00000% '
                                (!IWViewModel.LocaleCheckFlag() || IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('WeightingsSaveTotalError') == -1) ? "The total for weightings should be 100.00000% " : IWViewModel.ObjGeneralSettings.LocalizedTextList()[IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('WeightingsSaveTotalError')].Name()
                                , 'Error', system.getModuleId(IWViewModel), true);
                        }
                        else {
                            IWViewModel.WeightingsList([]);
                            app.showMessage(
                                //"Would you like to copy over same weights to all Business Units?"
                                (!IWViewModel.LocaleCheckFlag() || IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CopyWeightsBUAcknowledgement') == -1) ? "Would you like to copy over same weights to all Business Units?" : IWViewModel.ObjGeneralSettings.LocalizedTextList()[IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CopyWeightsBUAcknowledgement')].Name
                                , (!IWViewModel.LocaleCheckFlag() || IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveCopyOver') == -1) ? "Save/Copy Over" : IWViewModel.ObjGeneralSettings.LocalizedTextList()[IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SaveCopyOver')].Name
                                //"Save/Copy Over"
                                , [
                                    //"Yes"
                                    ((!IWViewModel.LocaleCheckFlag() || IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('YesKeyword') == -1) ? "Yes" : IWViewModel.ObjGeneralSettings.LocalizedTextList()[IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('YesKeyword')].Name)
                                    , ((!IWViewModel.LocaleCheckFlag() || IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoKeyword') == -1) ? "No" : IWViewModel.ObjGeneralSettings.LocalizedTextList()[IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('NoKeyword')].Name)
                                    //"No"
                                ], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus", popupIcon: 'title-icon col-md-1 fa fa-copy' })
                                .then(function (option) {
                                    if (option == ((!IWViewModel.LocaleCheckFlag() || IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('YesKeyword') == -1) ? "Yes" : IWViewModel.ObjGeneralSettings.LocalizedTextList()[IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('YesKeyword')].Name)) {
                                        //Copy to all the business units
                                        for (var j = 0; j < IWViewModel.BusinessUnits().length; j++) {
                                            for (var i = 0; i < IWViewModel.AreasOrQuestions().length; i++) {
                                                IWViewModel.WeightingsList.push(new WeightingsModel({ BuId: IWViewModel.BusinessUnits()[j].BUId(), RiskAreaId: IWViewModel.AreasOrQuestions()[i].AreaId(), WeightingValue: IWViewModel.AreasOrQuestions()[i].selectedBuWeight() }));
                                            }
                                        }
                                        saveWeights();
                                    }
                                    else {
                                        for (i = 0; i < IWViewModel.AreasOrQuestions().length; i++) {
                                            IWViewModel.WeightingsList.push(new WeightingsModel({ BuId: IWViewModel.SelectBusinessUnit().BUId(), RiskAreaId: IWViewModel.AreasOrQuestions()[i].AreaId(), WeightingValue: IWViewModel.AreasOrQuestions()[i].selectedBuWeight() }));
                                        }
                                        saveWeights();
                                    }
                                });
                        }
                    }
                });
        }

        function ToggleNavigationMenu1() {
            var chk2 = $('#NavigationToggle2');
            chk2.prop("checked", false);
            $("#FilterAreaAccordion").toggleClass("collapsedTreeview");
            $("#WeightingsTableDiv").toggleClass("col-lg-9 col-lg-12");
            $("#WeightingsTableDiv").toggleClass("col-md-9 col-md-12");
            $("#WeightingsTableDiv").toggleClass("col-sm-9 col-sm-12");
            $("#WeightingsTableDiv").toggleClass("col-xs-9 col-xs-12");
            $("#divNavSwitch2").show();
            $("#divjsTree").hide();
            $("#divExpandSwitch").hide();
        }
        function ToggleNavigationMenu2() {
            var chk1 = $('#NavigationToggle1');
            chk1.prop("checked", true);
            $("#FilterAreaAccordion").toggleClass("collapsedTreeview");
            $("#WeightingsTableDiv").toggleClass("col-lg-12 col-lg-9");
            $("#WeightingsTableDiv").toggleClass("col-md-12 col-md-9");
            $("#WeightingsTableDiv").toggleClass("col-sm-12 col-sm-9");
            $("#WeightingsTableDiv").toggleClass("col-xs-12 col-xs-9");
            $("#divNavSwitch2").hide();
            $("#divjsTree").show();
            $("#divExpandSwitch").show();
        }

        function CollapseAllTreeView() {
            if ($('#spanExpandAll').text() ===
                //"Expand"
                ((!IWViewModel.LocaleCheckFlag() || IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton') == -1) ? 'Expand' : IWViewModel.ObjGeneralSettings.LocalizedTextList()[IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton')].Name())
            ) {
                $('#jsTreeAreaLevelINHWIA').treeview('collapseAll', { silent: true });
                $("#spanExpandAll").text(
                    //"Collapse"
                    ((!IWViewModel.LocaleCheckFlag() || IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CollapseButton') == -1) ? 'Collapse' : IWViewModel.ObjGeneralSettings.LocalizedTextList()[IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CollapseButton')].Name())
                );
            }
            else {
                $('#jsTreeAreaLevelINHWIA').treeview('expandAll', { silent: true });
                $("#spanExpandAll").text(
                    //"Expand"
                    (!IWViewModel.LocaleCheckFlag() || IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton') == -1) ? 'Expand' : IWViewModel.ObjGeneralSettings.LocalizedTextList()[IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton')].Name()
                );
            }
        }

        function EditBUWeights(data, event) {
            try {
                var curr = event.currentTarget.parentElement.children[0].id;
                setSelectedBusinessUnit(curr);
                $("div.dataTables_scrollBody").animate({ scrollLeft: 0 }, 800);

            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: EditBUWeights() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function setSelectedBusinessUnit(id) {
            try {
                for (var i = 0; i < IWViewModel.BusinessUnits().length; i++) {
                    if (IWViewModel.BusinessUnits()[i].BUId() == id) {
                        IWViewModel.SelectBusinessUnit(IWViewModel.BusinessUnits()[i]);
                        break;
                    }
                }
                IWViewModel.EditableBusinessUnitName(IWViewModel.SelectBusinessUnit().BUName());
                IWViewModel.EditableBusinessunitTotal(parseInt(IWViewModel.SelectBusinessUnit().total()).toFixed(IWViewModel.decimalLimit()));
                for (i = 0; i < IWViewModel.AreasOrQuestions().length; i++) {
                    IWViewModel.AreasOrQuestions()[i].selectedBuWeight(IWViewModel.SelectBusinessUnit().BUWeightings[i].WeightingValue());
                    IWViewModel.AreasOrQuestions()[i].Applicability(IWViewModel.SelectBusinessUnit().BUWeightings[i].Applicability());
                }
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: setSelectedBusinessUnit() method in AMLControlsWeightings.js';
                logger.logMessage(msg);
            }

        }

        function GetQuestionTypes() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                getTaxonomyLevel = {

                    url: "/api/WeightingsThresholds/GetQuestionTypes",
                    type: "GET",
                    //data: { "RiskAreType": IWViewModel.SurveyTypeClicked(), "SurveyCategoryID": IWViewModel.SurveyCategoryID().toString(), "AssessmentTypes": IWViewModel.AssessmentTypeId().toString(), "ScreenType": 'W' },
                    headers: headers
                };
                $.ajax(getTaxonomyLevel)
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetQuestionTypes() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                //$('.content').show();
                //$('#mainLoader').hide();
                if (jsonResult !== null) {
                    IWViewModel.QuestionTypes([]);
                    var MappedQuestionTypes = $.map(jsonResult, function (result) {
                        return new QuestionTypeModel(result);
                    });
                    IWViewModel.QuestionTypes(MappedQuestionTypes);

                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status === 401) {
                        app.showMessage(((!IWViewModel.LocaleCheckFlag() || IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : IWViewModel.ObjGeneralSettings.LocalizedTextList()[IWViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then((option) => {
                                if (option === "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetQuestionTypes method in InherentWeightings.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    let msg = 'Exception: ' + e + ' | Source: ajaxFail in GetQuestionTypes method in InherentWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }

        //-------------------------------------------------------------------Model Definition Starts Here-------------------------------------------------------------------------

        function SurveyCategoryModel(item) {
            try {
                var self = this;
                self.SurveyCategoryId = ko.observable(item.SurveyCategoryId);
                self.SurveyCategoryName = ko.observable(item.SurveyCategoryName);
                self.SurveyCategoryShortName = ko.observable(item.SurveyCategoryShortName);
                self.SurveyType = ko.observable(item.SurveyType);
                self.Applicability = ko.observable(item.Applicability);
                self.SurveyGroupId = ko.observable(item.SurveyGroupId);
                self.SurveyGroupFullName = ko.observable(item.SurveyGroupFullName);
                self.SurveyGroupShortName = ko.observable(item.SurveyGroupShortName);
                self.IsEditable = ko.observable(item.IsEditable);
                self.AssessmentTypeId = ko.observable(item.AssessmentTypeId);
                self.AssessmentTypeName = ko.observable(item.AssessmentTypeName);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SurveyCategoryModel() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function BusinessLevelModel(item) {
            try {
                var self = this;
                self.Bulevel = ko.observable($('<div/>').html(item.BuLId).text());
                self.BlName = ko.observable($('<div/>').html(item.BuLevelName).text());
                self.SortOrder = ko.observable($('<div/>').html(item.SortOrder).text());
            } catch (e) {
                let msg = 'Exception: ' + e + ' | Source: BusinessLevelModel() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
        }
        function TaxonomyModel(item) {
            try {
                var self = this;
                self.LevelId = ko.observable(item.LevelId);
                self.LevelName = ko.observable(item.LevelName);
                self.isMaxLevel = ko.observable(item.isMaxLevel);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: TaxonomyModel() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
        }
        function QuestionTypeModel(item) {
            try {
                var self = this;
                self.QuestionType = ko.observable(item.QuestionType);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: QuestionTypeModel() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function BusinessLevelsModel(item) {
            try {
                var self = this;
                self.BUId = ko.observable(item.BusinessUnitId);
                self.BUName = ko.observable(item.BusinessUnitName);
                if (item.BusinessUnitName.length > 18) {
                    self.BUShortName = ko.observable((item.BusinessUnitName).substring(0, 15) + '...');
                }
                else
                    self.BUShortName = ko.observable(item.BusinessUnitName);
                if (item.BUWeightings !== undefined && item.BUWeightings !== null) {
                    var MappedWeights = $.map(item.BUWeightings, (result) => {
                        return new WeightingsModel(result);
                    });
                    self.BUWeightings = MappedWeights;
                }
                self.total = ko.computed(function () {
                    var total = 0;
                    for (var p = 0; p < self.BUWeightings.length; ++p) {
                        total += Number(Number(self.BUWeightings[p].WeightingValue()).toFixed(IWViewModel.decimalLimit()));
                    }
                    return total.toFixed(IWViewModel.decimalLimit());
                });
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: BusinessLevelsModel() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function RiskAreaModel(item) {
            try {
                var self = this;
                if (item.QuestionType == null) {
                    self.QuestionType = '';
                }
                else
                    self.QuestionType = item.QuestionType;
                IWViewModel.isHeaderQuestion(item.QuestionType);
                self.AreaId = ko.observable(item.AreaId);
                self.AreaName = ko.observable(item.AreaName);
                if (item.AreaName.length > 43) {
                    self.AreaShortName = ko.observable((item.AreaName).substring(0, 40) + '...');
                }
                else
                    self.AreaShortName = ko.observable(item.AreaName);
                if (item.AreaWeightings !== undefined && item.AreaWeightings !== null) {
                    var MappedWeights = $.map(item.AreaWeightings, (result) => {
                        return new WeightingsModel(result);
                    });
                    self.AreaWeightings = MappedWeights;
                }
                self.selectedBuWeight = ko.observable(0);
                self.selectedBuWeight.subscribe(function (newVal) {
                    if ($.isNumeric(newVal) && newVal >= 0.00000 && newVal <= 100.00000) {
                        var total = 0;
                        for (var i = 0; i < IWViewModel.AreasOrQuestions().length; i++) {
                            total += Number(Number(IWViewModel.AreasOrQuestions()[i].selectedBuWeight()));
                        }
                        IWViewModel.EditableBusinessunitTotal(total.toFixed(IWViewModel.decimalLimit()));
                    }
                    else if ($.isNumeric(newVal) && (newVal < 0.00000 || newVal > 100.00000)) {
                        this.selectedBuWeight(0);
                        logger.logError('Value should be in range of (0-100).', 'Error', system.getModuleId(IWViewModel), true);
                    }
                    else {
                        this.selectedBuWeight(0);
                        logger.logError('Non-numeric values are not allowed.', 'Error', system.getModuleId(IWViewModel), true);
                    }
                }, this);

                self.Applicability = ko.observable(0);
                self.Applicability.subscribe(function (newVal) {
                    this.Applicability(newVal);
                }, this);

            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: RiskAreaModel() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function WeightingsModel(item) {
            try {
                var self = this;
                self.BuId = ko.observable(item.BuId);
                self.RiskAreaId = ko.observable(item.RiskAreaId);
                self.WeightingValue = ko.observable(item.WeightingValue);
                self.Applicability = ko.observable(item.Applicability);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: WeightingsModel() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function TaxonomyModel(item) {
            try {
                var self = this;
                self.LevelId = ko.observable(item.LevelId);
                self.LevelName = ko.observable(item.LevelName);
                self.isMaxLevel = ko.observable(item.isMaxLevel);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: TaxonomyModel() method in InherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function jsTreeModel(item) {
            var self = this;

            self.id = item.AreaLevelId.toString();
            self.text = item.AreaLevelName;
            if (IWViewModel.AreaLeveljstree()[self.id].length > 0) {
                self.nodes = $.map(IWViewModel.AreaLeveljstree()[self.id], (result) => {
                    return new jsTreeModel(result);
                });
            }
            self.state = { expanded: true };
            self.dead_node = item.DeadNode;
            self.assessmentTypeList = ko.observableArray(item.AssessmentTypeList);
            self.RA_Type = ko.observable(item.RA_Type);

        }

        //-------------------------------------------------------------------Model Definition Ends Here----------------------------------------------------------------------------
    });


//-------------------------------------------------------------------------------------------------------------------------------------------------

;
